import { render, staticRenderFns } from "./JG.vue?vue&type=template&id=fb3dca18&"
import script from "./JG.vue?vue&type=script&lang=js&"
export * from "./JG.vue?vue&type=script&lang=js&"
import style0 from "./JG.vue?vue&type=style&index=0&id=fb3dca18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports